import React from 'react';
import { Card, Tag, List } from 'antd';
import { CheckItemRow } from './CheckItemRow';
import { CAT_CONFIG } from '../constants';
import type { ListingCheckResult, CheckItemUpdate } from '../types';

interface CategoryCardProps {
    categoryKey: string;
    items: ListingCheckResult[];
    onUpdateItem: (itemId: number, updates: CheckItemUpdate) => void;
}

export const CategoryCard: React.FC<CategoryCardProps> = ({ categoryKey, items, onUpdateItem }) => {
    if (items.length === 0) return null;

    const catName = items[0]?.item_info?.category_display || categoryKey.toUpperCase();
    const compliantCount = items.filter(i => i.is_compliant).length;

    return (
        <Card
            size="small"
            title={catName}
            extra={
                <Tag color={CAT_CONFIG[categoryKey]?.color || 'default'}>
                    {compliantCount}/{items.length}
                </Tag>
            }
            style={{ marginBottom: 16 }}
            bodyStyle={{ padding: '0 12px' }}
        >
            <List
                size="small"
                dataSource={items}
                renderItem={item => (
                    <CheckItemRow
                        key={item.id || `item-${item.item}`}
                        result={item}
                        onUpdate={onUpdateItem}
                    />
                )}
                split={false}
            />
        </Card>
    );
};
